/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusKundeEinstellungenDto } from '../../models/lexplus-kunde-einstellungen-dto';

export interface KundenControllerGetKundeEinstellungenV1$Params {
}

export function kundenControllerGetKundeEinstellungenV1(http: HttpClient, rootUrl: string, params?: KundenControllerGetKundeEinstellungenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusKundeEinstellungenDto>> {
  const rb = new RequestBuilder(rootUrl, kundenControllerGetKundeEinstellungenV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusKundeEinstellungenDto>;
    })
  );
}

kundenControllerGetKundeEinstellungenV1.PATH = '/v1/kunden/settings';
